import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { FormGroup, Form, Container, Row, Col, Fade, Alert } from "reactstrap";
import {
  ButtonLogin,
  InputLogin,
  CaptchaBox,
  InstructionText,
  InputAuth,
  EyeIcon,
  ProgressBar,
  ProgressBarWrapper,
} from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

import ls from "../../services/localStorage/index";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
/* import ReCAPTCHA from "react-google-recaptcha"; */
import api from "../../services/client/api";
import {
  validarTelefone,
  validarData,
  validarEmail,
  validarNome,
  validarNomeMae,
} from "../../utils/formValidations.js";
import moment from "moment";

const RegisterView = () => {
  const location = useLocation();
  const history = useHistory();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [tel_user, setTelefone] = useState("");
  const [responseAlert, setResponseAlert] = useState("");
  const [dataNasc, setDataNasc] = useState("");
  const [mother_name_user, setMotherName] = useState("");
  const [inProgress, setInProgress] = useState(false);
  /* const [recaptchaToken, setRecaptchaToken] = useState(''); */
  const { cpf_user } = location.state || {};
  const [modal, setModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const toggle = () => setModal(!modal);

  if (!cpf_user) {
    history.replace("/login");
  }

  const calculateStrength = (password) => {
    let strength = 0;

    const lengthCriteria = password.length >= 8;
    const specialCharCriteria = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const upperLowerCaseCriteria =
      /[a-z]/.test(password) && /[A-Z]/.test(password);
    const numberCriteria = /[0-9]/.test(password);

    if (lengthCriteria) strength += 25;
    if (specialCharCriteria) strength += 25;
    if (upperLowerCaseCriteria) strength += 25;
    if (numberCriteria) strength += 25;

    return strength;
  };

  const [strength, setStrength] = useState(0);

  useEffect(() => {
    const currentStrength = calculateStrength(password);
    setStrength(currentStrength);

    // Verifique se todos os critérios foram atendidos
  }, [password, passwordConfirmation]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInProgress(true);

    if (name === "") {
      setResponseAlert("Por favor, informe o nome completo.");
      setInProgress(false);
      return;
    }

    if (!validarNome(name)) {
      setResponseAlert("Por favor, forneça um nome válido.");
      setInProgress(false);
      return;
    }

    if (mother_name_user === "") {
      setResponseAlert("Por favor, informe o nome da genitora.");
      setInProgress(false);
      return;
    }

    if (!validarNomeMae(mother_name_user)) {
      setResponseAlert(
        "Nome de genitora inválido. Por favor, forneça um nome válido.",
      );
      setInProgress(false);
      return;
    }

    if (dataNasc === "") {
      setResponseAlert("Por favor, informe a data de nascimento.");
      setInProgress(false);
      return;
    }

    if (!validarData(dataNasc)) {
      setResponseAlert(
        "Data de nascimento inválida. Verifique o formato e tente novamente.",
      );
      setInProgress(false);
      return;
    }

    if (tel_user === "") {
      setResponseAlert("Por favor, informe o número de telefone.");
      setInProgress(false);
      return;
    }

    if (!validarTelefone(tel_user.replace(/\D/g, ""))) {
      setResponseAlert(
        "Número de telefone inválido. Verifique e tente novamente.",
      );
      setInProgress(false);
      return;
    }

    if (email === "") {
      setResponseAlert("Por favor, informe o endereço de e-mail.");
      setInProgress(false);
      return;
    }

    if (!validarEmail(email)) {
      setResponseAlert(
        "E-mail inválido. Por favor, forneça um endereço de e-mail válido.",
      );
      setInProgress(false);
      return;
    }

    if (password !== passwordConfirmation) {
      setResponseAlert("As senhas não correspondem.");
      setInProgress(false);
      return;
    }

    if (password.length < 8) {
      setResponseAlert("A senha deve conter no mínimo 8 caracteres.");
      setInProgress(false);
      return;
    }

    if (!/[A-Z]/.test(password)) {
      setResponseAlert("A senha deve conter pelo menos uma letra maiúscula.");
      setInProgress(false);
      return;
    }

    if (!/[a-z]/.test(password)) {
      setResponseAlert("A senha deve conter pelo menos uma letra minúscula.");
      setInProgress(false);
      return;
    }

    if (!/[0-9]/.test(password)) {
      setResponseAlert("A senha deve conter pelo menos um número.");
      setInProgress(false);
      return;
    }

    if (!/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\;]/.test(password)) {
      setResponseAlert(
        "A senha deve conter pelo menos um caractere especial (@, $, #...).",
      );
      setInProgress(false);
      return;
    }

    const dataNascFormatada = moment(dataNasc, "DD/MM/YYYY").format(
      "YYYY-MM-DDTHH:mm:ss[Z]",
    );
    const formData = {
      name: name.toUpperCase(), // Nome em maiúsculas
      email: email.toLowerCase(), // Email em minúsculas
      birthday_user: dataNascFormatada,
      cpf_user,
      tel_user: "55" + tel_user.replace(/\D/g, ""), // Corrigido isso também
      mother_name_user: mother_name_user.toUpperCase(), // Nome da mãe em maiúsculas
      username: cpf_user,
      password: password,
      /*     recaptcha_token: recaptchaToken, */
    };

    try {
      const response = await api().user().preRegister(formData);

      if (response.status === 201 && response.output.status === "success") {
        await ls().set("userDataToken", response.output.userDataToken, 60); // expira em 60 minutos
        await ls().set("sessionTokenVeriff", response.output.sessionToken, 60);
        // Redireciona diretamente para a URL fornecida
        window.location.replace(response.output.url);
      }
    } catch (error) {
      alert(
        "Informamos que, no momento, o sistema responsável pela biometria facial está temporariamente indisponível devido a uma manutenção programada. Pedimos a gentileza de tentar novamente em breve. Agradecemos a sua compreensão.",
      );
      history.replace("/login");
    } finally {
      setInProgress(false);
    }
    toggle();
  };

  const handleDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.length > 2) {
      value = `${value.slice(0, 2)}/${value.slice(2)}`;
    }
    if (value.length > 5) {
      value = `${value.slice(0, 5)}/${value.slice(5)}`;
    }

    setDataNasc(value);
  };

  const applyPhoneMask = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const match = cleanedValue.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);

    if (match) {
      return `${match[1] ? "(" + match[1] : ""}${match[2] ? ") " + match[2] : ""}${match[3] ? "-" + match[3] : ""}`;
    }

    return value;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  /* 
  const onChangeCap = (value) => {
    setRecaptchaToken(value);
  }; */
  useEffect(() => {
    if (responseAlert) {
      setShowAlert(true); // mostra com fade

      const timeout = setTimeout(() => {
        setShowAlert(false); // começa a esconder com fade
        // depois que sumir, limpa o conteúdo
        setTimeout(() => setResponseAlert(""), 700);
      }, 7000);

      return () => clearTimeout(timeout);
    }
  }, [responseAlert]);

  return (
    <Container>
      <div
        style={{ marginTop: "20px", marginBottom: "20px", fontWeight: "bold" }}
      >
        Dados cadastrais <FontAwesomeIcon icon={faAddressCard} />
      </div>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={12}>
            <FormGroup>
              <span
                style={{
                  display: "block",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  fontWeight: 650,
                  fontSize: "15px",
                  color: "#6c757d",
                  textAlign: "left",
                }}
              >
                Digite seu nome completo:
              </span>
              <InputLogin
                type="text"
                placeholder="Nome completo"
                maxLength="120"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyPress={handleKeyPress} // Adicionado aqui
                /*    disabled={isFieldsDisabled}  */
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <FormGroup>
              <span
                style={{
                  display: "block",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  fontWeight: 650,
                  fontSize: "15px",
                  color: "#6c757d",
                  textAlign: "left",
                }}
              >
                Nome completo da genitora:
              </span>
              <InputLogin
                type="text"
                placeholder="Nome da Mãe"
                maxLength="120"
                value={mother_name_user}
                onChange={(e) => setMotherName(e.target.value)}
                onKeyPress={handleKeyPress} // Adicionado aqui
                required
                /*     disabled={isFieldsDisabled}  */
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FormGroup>
              <span
                style={{
                  display: "block",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  fontWeight: 650,
                  fontSize: "15px",
                  color: "#6c757d",
                  textAlign: "left",
                }}
              >
                Digite sua data de nascimento:
              </span>
              <InputLogin
                type="text"
                placeholder="Data de nascimento"
                value={dataNasc}
                onChange={handleDateChange}
                onKeyPress={handleKeyPress} // Adicionado aqui
                maxLength="10"
                required
                /*   disabled={isFieldsDisabled}  */
              />
            </FormGroup>
          </Col>
          <Col xs={12} md={6}>
            <FormGroup>
              <span
                style={{
                  display: "block",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  fontWeight: 650,
                  fontSize: "15px",
                  color: "#6c757d",
                  textAlign: "left",
                }}
              >
                Número de telefone:
              </span>
              <InputLogin
                type="text"
                placeholder="Digite seu telefone"
                value={applyPhoneMask(tel_user)}
                onChange={(e) => setTelefone(e.target.value)}
                onKeyPress={handleKeyPress}
                maxLength="15"
                required
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12}>
            <FormGroup>
              <span
                style={{
                  display: "block",
                  marginBottom: "0px",
                  marginLeft: "20px",
                  fontWeight: 650,
                  fontSize: "15px",
                  color: "#6c757d",
                  textAlign: "left",
                }}
              >
                Digite seu endereço de e-mail:
              </span>
              <InputLogin
                type="email"
                placeholder="Digite seu email"
                value={email}
                maxLength="250"
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress} // Adicionado aqui
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <div
          style={{
            backgroundColor: "#1001",
            padding: "20px",
            borderRadius: "20px",
          }}
        >
          <div style={{ marginBottom: "20px", fontWeight: "bold" }}>
            Defina uma senha <FontAwesomeIcon icon={faAddressCard} />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: "100%",
            }}
          >
            {/* CENTRALIZAR AQUI */}
            <Row>
              <Col xs={12} md={12}>
                <FormGroup>
                  <div style={{ position: "relative" }}>
                    <InputAuth
                      type={showPassword ? "text" : "password"}
                      placeholder="Digite a senha"
                      value={password}
                      maxLength="64"
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={handleKeyPress}
                      required
                    />
                    <EyeIcon onClick={() => setShowPassword(!showPassword)}>
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />
                    </EyeIcon>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <FormGroup>
                  <div style={{ position: "relative" }}>
                    <InputAuth
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Confirme a senha"
                      value={passwordConfirmation}
                      maxLength="64"
                      onChange={(e) => setPasswordConfirmation(e.target.value)}
                      onKeyPress={handleKeyPress}
                      required
                    />
                    <EyeIcon
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      <FontAwesomeIcon
                        icon={showConfirmPassword ? faEyeSlash : faEye}
                      />
                    </EyeIcon>
                  </div>
                  <ProgressBarWrapper>
                    <ProgressBar strength={strength} />
                  </ProgressBarWrapper>

                  {/*  {strength > 25 && strength < 100 && (
                                    <p style={{ color: 'red' }}></p>
                                    )} */}

                  {strength === 100 && (
                    <p style={{ color: "green" }}>Senha válida</p>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <InstructionText>
              Escolha uma senha forte utilizando:
              <ul>
                <li>A senha deve conter no mínimo 8 caracteres</li>
                <li>Caracteres especiais (@, $, #...)</li>
                <li>Letras maiúsculas e minúsculas (A, a)</li>
                <li>Números e letras (a123)</li>
              </ul>
            </InstructionText>
            {/* CENTRALIZAR AQUI */}
          </div>
        </div>
        <CaptchaBox>
          {/*  <ReCAPTCHA
                sitekey="6LdNeeQrAAAAAEWDlO_OW-s11Zg8sL51BCq0dgi7"
                onChange={onChangeCap}
              
              /> */}
        </CaptchaBox>
        {responseAlert && (
          <>
            {showAlert && (
              <Fade in={showAlert} timeout={600}>
                <Alert style={{ marginTop: "10px" }} color="danger">
                  {responseAlert}
                </Alert>
              </Fade>
            )}
          </>
        )}
        <ButtonLogin type="submit" disabled={inProgress}>
          Enviar
          <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: "10px" }} />
        </ButtonLogin>
      </Form>
    </Container>
  );
};

export default RegisterView;
